export default __webpack_public_path__ + "static/four_oh_four-e66bad5e0be5a17a850a26ef7893c9f5.png";